if (process.env.REACT_APP_NODE_ENVIRONMENT === 'prod') {
  module.exports = {
    REACT_APP_API_BASE_URL: process.env.REACT_APP_PROD_API_BASE_URL,
    REACT_APP_NODE_ENV: process.env.REACT_APP_NODE_ENV,
    REACT_APP_NODE_ENVIRONMENT: process.env.REACT_APP_NODE_ENVIRONMENT,
    REACT_APP_CLIENT_ID: process.env.REACT_APP_PROD_CLIENT_ID,
    REACT_APP_UNAUTH_WHITELISTED_DOMAIN: process.env.REACT_APP_PROD_UNAUTH_WHITELISTED_DOMAIN,
    REACT_APP_AMAZON_CHAT_REGION: process.env.REACT_APP_PROD_AMAZON_CHAT_REGION,
    REACT_APP_AMAZON_CHAT_API_GATEWAY: process.env.REACT_APP_PROD_AMAZON_CHAT_API_GATEWAY,
    REACT_APP_AMAZON_CHAT_ENABLE_ATTACHMENTS: process.env.REACT_APP_PROD_AMAZON_CHAT_ENABLE_ATTACHMENTS,
    REACT_APP_AMAZON_CHAT_ASYNC_MATCH_PARAMS: process.env.REACT_APP_PROD_AMAZON_CHAT_ASYNC_MATCH_PARAMS,
  };
} else if (process.env.REACT_APP_NODE_ENVIRONMENT === 'stage') {
  module.exports = {
    REACT_APP_API_BASE_URL: process.env.REACT_APP_STAGE_API_BASE_URL,
    REACT_APP_NODE_ENV: process.env.REACT_APP_NODE_ENV,
    REACT_APP_NODE_ENVIRONMENT: process.env.REACT_APP_NODE_ENVIRONMENT,
    REACT_APP_CLIENT_ID: process.env.REACT_APP_STAGE_CLIENT_ID,
    REACT_APP_UNAUTH_WHITELISTED_DOMAIN: process.env.REACT_APP_STAGE_UNAUTH_WHITELISTED_DOMAIN,
    REACT_APP_AMAZON_CHAT_REGION: process.env.REACT_APP_STAGE_AMAZON_CHAT_REGION,
    REACT_APP_AMAZON_CHAT_API_GATEWAY: process.env.REACT_APP_STAGE_AMAZON_CHAT_API_GATEWAY,
    REACT_APP_AMAZON_CHAT_ENABLE_ATTACHMENTS: process.env.REACT_APP_STAGE_AMAZON_CHAT_ENABLE_ATTACHMENTS,
    REACT_APP_AMAZON_CHAT_ASYNC_MATCH_PARAMS: process.env.REACT_APP_STAGE_AMAZON_CHAT_ASYNC_MATCH_PARAMS,
  };
} else if (process.env.REACT_APP_NODE_ENVIRONMENT === 'local') {
  module.exports = {
    REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    REACT_APP_NODE_ENV: process.env.REACT_APP_NODE_ENV,
    REACT_APP_NODE_ENVIRONMENT: process.env.REACT_APP_NODE_ENVIRONMENT,
    REACT_APP_CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
    REACT_APP_UNAUTH_WHITELISTED_DOMAIN: process.env.REACT_APP_UNAUTH_WHITELISTED_DOMAIN,
    REACT_APP_AMAZON_CHAT_REGION: process.env.REACT_APP_AMAZON_CHAT_REGION,
    REACT_APP_AMAZON_CHAT_API_GATEWAY: process.env.REACT_APP_AMAZON_CHAT_API_GATEWAY,
    REACT_APP_AMAZON_CHAT_ENABLE_ATTACHMENTS: process.env.REACT_APP_AMAZON_CHAT_ENABLE_ATTACHMENTS,
    REACT_APP_AMAZON_CHAT_ASYNC_MATCH_PARAMS: process.env.REACT_APP_AMAZON_CHAT_ASYNC_MATCH_PARAMS,
  };
} else if (process.env.REACT_APP_NODE_ENVIRONMENT === 'qe') {
  module.exports = {
    REACT_APP_API_BASE_URL: process.env.REACT_APP_QE_API_BASE_URL,
    REACT_APP_NODE_ENV: process.env.REACT_APP_NODE_ENV,
    REACT_APP_NODE_ENVIRONMENT: process.env.REACT_APP_NODE_ENVIRONMENT,
    REACT_APP_CLIENT_ID: process.env.REACT_APP_QE_CLIENT_ID,
    REACT_APP_UNAUTH_WHITELISTED_DOMAIN: process.env.REACT_APP_QE_UNAUTH_WHITELISTED_DOMAIN,
    REACT_APP_AMAZON_CHAT_REGION: process.env.REACT_APP_QE_AMAZON_CHAT_REGION,
    REACT_APP_AMAZON_CHAT_API_GATEWAY: process.env.REACT_APP_QE_AMAZON_CHAT_API_GATEWAY,
    REACT_APP_AMAZON_CHAT_ENABLE_ATTACHMENTS: process.env.REACT_APP_QE_AMAZON_CHAT_ENABLE_ATTACHMENTS,
    REACT_APP_AMAZON_CHAT_ASYNC_MATCH_PARAMS: process.env.REACT_APP_QE_AMAZON_CHAT_ASYNC_MATCH_PARAMS,
  };
} else if (process.env.REACT_APP_NODE_ENVIRONMENT === 'develop') {
  module.exports = {
    REACT_APP_API_BASE_URL: process.env.REACT_APP_DEV_API_BASE_URL,
    REACT_APP_NODE_ENV: process.env.REACT_APP_NODE_ENV,
    REACT_APP_NODE_ENVIRONMENT: process.env.REACT_APP_NODE_ENVIRONMENT,
    REACT_APP_CLIENT_ID: process.env.REACT_APP_DEV_CLIENT_ID,
    REACT_APP_UNAUTH_WHITELISTED_DOMAIN: process.env.REACT_APP_DEV_UNAUTH_WHITELISTED_DOMAIN,
    REACT_APP_AMAZON_CHAT_REGION: process.env.REACT_APP_DEV_AMAZON_CHAT_REGION,
    REACT_APP_AMAZON_CHAT_API_GATEWAY: process.env.REACT_APP_DEV_AMAZON_CHAT_API_GATEWAY,
    REACT_APP_AMAZON_CHAT_ENABLE_ATTACHMENTS: process.env.REACT_APP_DEV_AMAZON_CHAT_ENABLE_ATTACHMENTS,
    REACT_APP_AMAZON_CHAT_ASYNC_MATCH_PARAMS: process.env.REACT_APP_DEV_AMAZON_CHAT_ASYNC_MATCH_PARAMS,
  };
} else {
  module.exports = {
    REACT_APP_API_BASE_URL: process.env.REACT_APP_DEV_API_BASE_URL,
    REACT_APP_NODE_ENV: process.env.REACT_APP_NODE_ENV,
    REACT_APP_NODE_ENVIRONMENT: process.env.REACT_APP_NODE_ENVIRONMENT,
    REACT_APP_CLIENT_ID: process.env.REACT_APP_DEV_CLIENT_ID,
    REACT_APP_UNAUTH_WHITELISTED_DOMAIN: process.env.REACT_APP_DEV_UNAUTH_WHITELISTED_DOMAIN,
    REACT_APP_AMAZON_CHAT_REGION: process.env.REACT_APP_DEV_AMAZON_CHAT_REGION,
    REACT_APP_AMAZON_CHAT_API_GATEWAY: process.env.REACT_APP_DEV_AMAZON_CHAT_API_GATEWAY,
    REACT_APP_AMAZON_CHAT_ENABLE_ATTACHMENTS: process.env.REACT_APP_DEV_AMAZON_CHAT_ENABLE_ATTACHMENTS,
    REACT_APP_AMAZON_CHAT_ASYNC_MATCH_PARAMS: process.env.REACT_APP_DEV_AMAZON_CHAT_ASYNC_MATCH_PARAMS,
  };
}
